import React, { useContext, useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import Modal from 'react-bootstrap/Modal';
import { AddOnCardModal } from './AddOnCardModal';
import ItemsCarousel from 'react-items-carousel';
import './BookingAddOnCardGroup.css';
import {
  InsuranceAddonContext,
  HealthCareAddOnContext,
  CurrentCurrencyContext,
  CurrencyContext,
  ValueMealAddonContext,
} from '../UserContext';
import HealthCare from './HealthCare';
import {
  getMonetaryUnitText,
  getToken,
  sessionStorageGetItem,
  sessionStorageSetItem,
} from './Function';
import axios from 'axios';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';

const CloseButton = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'>
      <path d='M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z' />
    </svg>
  );
};

const ShieldIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
    <path d='M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z' />
  </svg>
);

export const BookingAddOnCardGroup = ({ component, data }) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [isTravelPackagesShowed, setIsTravelPackagesShowed] = useState(false);
  const [isAddOnMealShowed, setIsAddOnMealShowed] = useState(false);
  const [isHealthCareShowed, setIsHealthCareShowed] = useState(false);
  const [packageSubtotal, setPackageSubTotal] = useState(0);

  const [departHealthCarePackages, setDepartHealthCarePackages] = useState([]);
  const [departInsurancePlans, setDepartInsurancePlans] = useState([]);

  const [returnHealthCarePackages, setReturnHealthCarePackages] = useState([]);
  const [returnInsurancePlans, setReturnInsurancePlans] = useState([]);

  const [hasSelectedPlan, setHasSelectedPlan] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState();

  const [hasSelectedMeal, setHasSelectedMeal] = useState(false);
  const [selectedMeal, setSelectedMeal] = useState();

  const [addOnMeals, setAddOnMeals] = useState([]);

  const { insuranceAddOn, setInsuranceAddOn } = useContext(
    InsuranceAddonContext
  );

  const { healthCardAddOn, setHealthCareAddOn } = useContext(
    HealthCareAddOnContext
  );

  const { valueMealAddon, setValueMealAddOn } = useContext(
    ValueMealAddonContext
  );

  const { currentCurrency, setCurrentCurrency } = useContext(
    CurrentCurrencyContext
  );

  const { exchangeCurrency, setExchangeCurrency } = useContext(CurrencyContext);

  const monetaryUnit = getMonetaryUnitText(currentCurrency);

  const [searchParams] = useSearchParams();
  const noOfPax = Number(searchParams.get('passenger') || 1);

  const chevronWidth = 40;

  let currentTotal = 0;

  component = component > 5 ? '5' : component;
  component = component < 5 && component > 2 ? '2' : component;
  component = component < 2 ? '1' : component;
  // console.log(data);
  // let package_data = null;
  // if(sessionStorageGetItem("addon_data")!=null) {
  //     package_data = JSON.parse(sessionStorageGetItem("addon_data"))
  // }
  // // console.log(JSON.parse(sessionStorageGetItem("addon_data")));

  const isReturnTrip = sessionStorageGetItem('return_TripKey') !== null;

  if (!isReturnTrip) {
    sessionStorage.removeItem('returnBusFare');
  }

  const plans = document.querySelectorAll('.travel-protection-plan');

  for (let i = 0; i < plans.length; i++) {
    plans[i].addEventListener('click', () => {
      if (hasSelectedPlan && selectedPlan !== plans[i].item_name) {
        return;
      } else {
        plans.forEach((e) => e.classList.remove('active'));
        plans[i].classList.add('active');
      }
    });
  }

  const handleInsuranceAddOn = (id, name, amount, direction) => {
    setInsuranceAddOn({
      addOnId: id,
      plan: name,
      fee: parseFloat(amount) * noOfPax,
      direction: direction,
      noOfPax,
    });

    sessionStorageSetItem(
      'insuranceAddOn',
      JSON.stringify({
        addOnId: id,
        plan: name,
        fee: parseFloat(amount) * noOfPax,
        direction: direction,
        noOfPax,
      })
    );
  };

  const handleMealAddOn = (id, name, amount, direction, canDelete) => {
    setValueMealAddOn({
      addOnId: id,
      item: name,
      fee: parseFloat(amount) * noOfPax * (isReturnTrip ? 2 : 1),
      direction: direction,
      noOfPax,
      canDelete,
      isReturnTrip: isReturnTrip,
    });

    sessionStorageSetItem(
      'valueMealAddOn',
      JSON.stringify({
        addOnId: id,
        item: name,
        fee: parseFloat(amount) * noOfPax * (isReturnTrip ? 2 : 1),
        direction: direction,
        noOfPax,
        canDelete,
        isReturnTrip: isReturnTrip,
      })
    );
  };

  const sessionInsurance = sessionStorageGetItem('insuranceAddOn');

  const sessionIA = JSON.parse(sessionInsurance || '{}');

  const sessionMeal = sessionStorageGetItem('valueMealAddOn');

  const sessionMA = JSON.parse(sessionMeal || '{}');

  useEffect(() => {
    setInsuranceAddOn(sessionIA);
    setValueMealAddOn(sessionMA);
  }, []);

  useEffect(() => {
    const getAddOn = () => {
      const addons = JSON.parse(sessionStorageGetItem('other_addon') || '[]');

      try {
        setDepartHealthCarePackages(
          addons.filter(
            (_) =>
              _.addon_type === 'zero_healthcare' && _.direction === 'depart'
          )
        );

        setReturnHealthCarePackages(
          addons.filter(
            (_) =>
              _.addon_type === 'zero_healthcare' && _.direction === 'return'
          )
        );

        setDepartInsurancePlans(
          addons.filter(
            (_) =>
              _.addon_type === 'travel_protection' && _.direction === 'depart'
          )
        );

        setReturnInsurancePlans(
          addons.filter(
            (_) =>
              _.addon_type === 'travel_protection' && _.direction === 'return'
          )
        );

        setAddOnMeals(
          addons.filter(
            (_) => _.addon_type === 'value_meal' && _.direction === 'depart'
          )
        );

        const healthCares = addons.filter(
          (_) => _.addon_type === 'zero_healthcare'
        );

        const insurances = addons.filter(
          (_) => _.addon_type === 'travel_protection'
        );

        const meals = addons.filter((_) => _.addon_type === 'value_meal');

        for (const insurance of insurances) {
          if (insurance.input_is_selected === 'True') {
            handleInsuranceAddOn(
              insurance.add_on_id,
              insurance.item_name,
              Number(insurance.item_amt),
              insurance.direction
            );

            setHasSelectedPlan(true);
            setSelectedPlan(insurance.item_name);
          }
        }

        for (const meal of meals) {
          if (meal.input_is_selected === 'True') {
            handleMealAddOn(
              meal.add_on_id,
              meal.item_name,
              Number(meal.item_amt),
              meal.direction,
              false
            );

            setHasSelectedMeal(true);
            setSelectedMeal(meal.item_name);
          }
        }

        if (insurances.length < 1) {
          setInsuranceAddOn({
            plan: 'No Insurance',
            fee: 0,
          });
          sessionStorageSetItem(
            'insuranceAddOn',
            JSON.stringify({
              plan: 'No Insurance',
              fee: 0,
            })
          );
        }

        if (healthCares.length < 1) {
          setHealthCareAddOn({ item: '', fee: 0, isReturn: false });
          sessionStorageSetItem(
            'healthCareAddOn',
            JSON.stringify({ item: '', fee: 0, isReturn: false })
          );
        }

        if (meals.length < 1) {
          setValueMealAddOn({ item: '', fee: 0 });
          sessionStorageSetItem(
            'valueMealAddOn',
            JSON.stringify({ item: '', fee: 0 })
          );
        }
      } catch (error) {
        setDepartHealthCarePackages([]);
        setDepartInsurancePlans([]);
        setReturnHealthCarePackages([]);
        setReturnInsurancePlans([]);
        setAddOnMeals([]);
      }
    };

    getAddOn();
  }, []);

  if (sessionStorageGetItem('addon_data') != 'undefined') {
    const package_data = JSON.parse(sessionStorageGetItem('addon_data'));
    // console.log(package_data);
    return (
      <>
        <div className='add-on-group' style={{ marginTop: '20px' }}>
          {addOnMeals.length > 0 && (
            <div
              className='value-meal'
              onClick={() => setIsAddOnMealShowed(true)}
            >
              <div className='add-on-image-wrapper'>
                <img
                  src={'images/addon/meal/img_value_meal.png'}
                  alt='add-on-banner'
                />
              </div>
              <h4 className='add-on-title'>Value Meal</h4>
              <div className='add-on-arrow'>
                <img alt='add-on-arrow' src='images/chevron-right-solid.svg' />
              </div>
            </div>
          )}

          {!isReturnTrip && departHealthCarePackages.length < 1 ? (
            ''
          ) : departHealthCarePackages.length > 0 ||
            returnHealthCarePackages.length > 0 ? (
            <div
              className='health-care'
              onClick={() => setIsHealthCareShowed(true)}
            >
              <div className='add-on-image-wrapper'>
                <img
                  src={'images/addon/zero_healthcare/zero-logo.png'}
                  alt='add-on-banner'
                  style={{ objectFit: 'contain' }}
                />
              </div>
              <h4 className='add-on-title'>Zero Health Care</h4>
              <div className='add-on-arrow'>
                <img alt='add-on-arrow' src='images/chevron-right-solid.svg' />
              </div>
            </div>
          ) : (
            ''
          )}

          {package_data && package_data.length > 0 ? (
            <div
              className='travel-package'
              onClick={() => setIsTravelPackagesShowed(true)}
            >
              <div className='add-on-image-wrapper'>
                <img
                  src={'images/addon/package/img_travel_package.png'}
                  alt='add-on-banner'
                />
              </div>
              <h4 className='add-on-title'>Travel Package</h4>
              <div className='add-on-arrow'>
                <img alt='add-on-arrow' src='images/chevron-right-solid.svg' />
              </div>

              <div
                className='add-on-packages'
                // style={{
                //   transition: 'all 0.2s ease-out',
                //   pointerEvents: isTravelPackagesShowed ? 'auto' : 'none',
                //   position: 'fixed',
                //   height: '100%',
                //   width: '100%',
                //   zIndex: 10,
                //   top: 0,
                //   left: 0,
                //   backgroundColor: 'rgba(0,0,0,0.5)',
                //   padding: 10,
                //   display: 'flex',
                //   alignItems: 'center',
                //   justifyContent: 'center',
                //   opacity: isTravelPackagesShowed ? 1 : 0,
                // }}
              >
                <div
                  className='packages-wrapper'
                  // style={{
                  //   width: '100%',
                  //   maxWidth: '600px',
                  //   backgroundColor: 'white',
                  //   borderRadius: '3px',
                  // }}
                >
                  {/* <div className='add-on-title-wrapper'>
              <h5>Travel Package</h5>
              <div
                className='image-wrapper'
                onClick={() => setIsTravelPackagesShowed(false)}
              >
                <CloseButton />
              </div>
            </div> */}

                  {package_data && package_data.length > 0 ? (
                    <div className='packages-container'>
                      {/* <div className='add-on-description-wrapper'>
                <p>
                  <strong>Pre-Book and save up to 44%</strong>
                </p>
                <p>You can pre-book up to 2 travel package</p>
              </div> */}
                      {package_data.map((p, index) => (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '10px',
                            padding: '10px',
                            border: '1px solid #d9d9d9',
                            borderRadius: '10px',
                          }}
                          key={index}
                          className='add-on-package'
                        >
                          <AddOnCardModal
                            img={p.image}
                            categories='CATEGORIES'
                            title={p.displayname}
                            myrPrice={p.priceinmyr}
                            sgdPrice={p.priceinsgd}
                            currentCurrency={currentCurrency}
                            label_id={p.labelid}
                            package_url={p.url}
                          />
                          {/* <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        position: "relative",
                      }}
                      className="add-on-package-image-wrapper"
                    >
                      <img
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          position: "absolute",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        src={p.image}
                        alt="package-banner-image"
                      />
                    </div>

                    <div className="package-details">
                      <h5>{p.displayname}</h5>
                      <p>
                        <span>MYR</span> {p.price}
                      </p>
                    </div>

                    <div className="package-add">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" />
                      </svg>
                    </div> */}
                        </div>
                      ))}
                    </div>
                  ) : (
                    ''
                  )}

                  {/* <div className="add-on-packages-sub-total">
              <div className="add-on-packages-sub-total-wrapper">
                <div className="price">
                  <p className="sub-total">Subtotal</p>
                  <p className="total">
                    <span>{packageSubtotal}</span> MYR
                  </p>
                </div>

                <div className="atc-button">Add On</div>
              </div>
            </div> */}
                </div>
              </div>
            </div>
          ) : (
            ''
          )}

          {departInsurancePlans.length > 0 ||
          returnInsurancePlans.length > 0 ? (
            <div className='travel-protection'>
              <div className='add-on-image-wrapper'>
                <img
                  src={'images/addon/insurance/img_travel_protection.png'}
                  alt='add-on-banner'
                />
              </div>
              <h4 className='add-on-title'>Travel Protection</h4>
              <div className='travel-protection-plans'>
                {departInsurancePlans.map((plan, index) => (
                  <div
                    className={`travel-protection-plan${
                      sessionIA.plan === plan.item_name ? ' active' : ''
                    }${
                      hasSelectedPlan && selectedPlan !== plan.item_name
                        ? ' disabled'
                        : ''
                    }${plan.input_is_disabled === 'True' ? ' disabled' : ''}`}
                    key={index}
                    onClick={() => {
                      if (hasSelectedPlan && selectedPlan !== plan.item_name) {
                        return;
                      }

                      handleInsuranceAddOn(
                        plan.add_on_id,
                        plan.item_name,
                        Number(plan.item_amt),
                        plan.direction
                      );
                    }}
                  >
                    <div className='plan-radio'></div>

                    <div className='plan-title'>
                      <ShieldIcon />
                      <h5>{plan.item_name}</h5>
                    </div>

                    <div
                      style={{ width: '100%', marginTop: '20px' }}
                      dangerouslySetInnerHTML={{ __html: plan.item_desc }}
                    />

                    {Number(plan.item_amt) > 0 ? (
                      <p className='plan-price'>
                        <span>
                          +{' '}
                          {(
                            Number(plan.item_amt) *
                            (currentCurrency === 'MYR'
                              ? 1
                              : exchangeCurrency.addOnCurrency)
                          ).toFixed(2)}
                        </span>{' '}
                        {monetaryUnit}
                      </p>
                    ) : (
                      ''
                    )}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
        {/* <div style={{ padding: `0 ${chevronWidth}px` }}>
          <ItemsCarousel
            requestToChangeActive={setActiveItemIndex}
            activeItemIndex={activeItemIndex}
            numberOfCards={component}
            gutter={20}
            leftChevron={<button>{"<"}</button>}
            rightChevron={<button>{">"}</button>}
            outsideChevron
            chevronWidth={chevronWidth}
          >
            {package_data &&
              package_data.map(
                ({ displayname, image, price, labelid, url }, index) => (
                  <AddOnCardModal
                    img={image}
                    categories="CATEGORIES"
                    title={displayname}
                    price={price}
                    label_id={labelid}
                    package_url={url}
                  />
                )
              )}
          </ItemsCarousel>
        </div> */}

        <div
          className='value-meals'
          style={{
            transition: 'all 0.2s ease-out',
            pointerEvents: isAddOnMealShowed ? 'auto' : 'none',
            position: 'fixed',
            height: '100%',
            width: '100%',
            zIndex: 10,
            top: 0,
            left: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            padding: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            opacity: isAddOnMealShowed ? 1 : 0,
          }}
        >
          <div
            className='meals-wrapper'
            style={{
              width: '100%',
              maxWidth: '600px',
              backgroundColor: 'white',
              borderRadius: '3px',
            }}
          >
            <div className='add-on-title-wrapper'>
              <h5>Meal Add On</h5>
              <div
                className='image-wrapper'
                onClick={() => setIsAddOnMealShowed(false)}
              >
                <CloseButton />
              </div>
            </div>
            <div className='packages-container'>
              {/* <div className='add-on-description-wrapper'>
                <p>
                  <strong>Pre-Book and save up to 44%</strong>
                </p>
                <p>You can pre-book up to 2 meals per trip</p>
              </div> */}

              {addOnMeals.map((p, key) => (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '10px',
                    padding: '10px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '10px',
                    backgroundColor:
                      p.input_is_disabled === 'True' ? '#e9e9e9' : '',
                    pointerEvents: p.input_is_disabled === 'True' ? 'none' : '',
                  }}
                  key={key}
                  className={`add-on-healthcare${
                    sessionMA?.item === p.item_name ? ' active' : ''
                  }${
                    hasSelectedMeal && selectedMeal !== p.item_name
                      ? ' disabled'
                      : ''
                  }${p.input_is_disabled === 'True' ? ' disabled' : ''}`}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      position: 'relative',
                    }}
                    className='add-on-package-image-wrapper'
                  >
                    <img
                      style={{
                        width: '100%',
                        borderRadius: '10px',
                        position: 'absolute',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                      src={p.item_images}
                      alt='package-banner-image'
                    />
                  </div>

                  <div className='package-details'>
                    <h5>{p.item_name}</h5>
                    <div
                      style={{ width: '100%', marginBottom: '10px' }}
                      dangerouslySetInnerHTML={{ __html: p.item_desc }}
                    />

                    <p>
                      <span>MYR</span> {p.item_amt}
                    </p>
                  </div>

                  <div
                    onClick={() => {
                      if (p.input_is_disabled === 'True') {
                        return;
                      }

                      if (sessionMA?.addOnId === p.add_on_id) {
                        return;
                      }
                      handleMealAddOn(
                        p.add_on_id,
                        p.item_name,
                        p.item_amt,
                        p.direction,
                        p.input_is_selected === 'False'
                      );
                    }}
                    className={`package-add${
                      sessionMA?.addOnId === p.add_on_id ? ' added' : ''
                    }`}
                    style={{
                      backgroundColor:
                        p.input_is_disabled === 'True' ? 'grey' : '',
                    }}
                  >
                    {sessionMA?.addOnId === p.add_on_id ? (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 448 512'
                      >
                        <path d='M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z' />
                      </svg>
                    ) : (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 448 512'
                      >
                        <path d='M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z' />
                      </svg>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {departHealthCarePackages.length > 0 ||
        returnHealthCarePackages.length > 0 ? (
          <HealthCare
            isReturnTrip={isReturnTrip}
            isHealthCareShowed={isHealthCareShowed}
            setIsHealthCareShowed={setIsHealthCareShowed}
            departHealthCarePackages={departHealthCarePackages}
            returnHealthCarePackages={returnHealthCarePackages}
          />
        ) : (
          ''
        )}
      </>
    );
  }
};
